import { api } from 'tools/api-service';

import { putProfileAvatarRequest } from './types/put-profile-avatar.type';

export const putProfileAvatar = async (
	{ profileImage }: putProfileAvatarRequest) => {
	const putProfileData = api.put<putProfileAvatarRequest>(
		'/account/profile/avatar',
		{
			profileImage,
		}
	);

	return putProfileData;
};
